import { useResponsiveTheme } from 'hooks/useResponsiveTheme/useResponsiveTheme';
import { ReactComponent as CloseIcon } from 'icons/close-icon.svg';
import { useTranslations } from 'utils/translations/useTranslations';
import './CloseModalButton.scss';

export const CloseModalButton = ({ onClick }: { onClick?: () => void }) => {
  const { responsive } = useResponsiveTheme();
  const i18n = useTranslations();

  return (
    <button
      className="closeButton"
      aria-label="Close"
      onClick={onClick}
      data-testid="closeModalButton"
    >
      <CloseIcon
        className="Icon Icon--xs marginRight-sm fill-color-white"
        aria-hidden
      />
      <span
        className={`closeButton-text ${responsive ? 'closeButton-text--responsive' : ''}`}
      >
        {i18n.t('checkout.closeButton.close')}
      </span>
    </button>
  );
};

CloseModalButton.displayName = 'CloseModalButton';
